var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-list-group-item',{staticStyle:{"text-align":"left","border":"0px","padding":"0.25vw 0 0.25vw 0vw"}},[_c('strong',[_vm._v(_vm._s(_vm.data.Date))]),_vm._v(": "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.data.Content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }